import { Model as t } from "../../../../model.js";
class n extends t {
  constructor(r) {
    super(), this.queryString = r.queryString, this.queryStringDict = r.queryStringDict;
  }
}
export {
  n as ShopSessionLandingModel
};
//# sourceMappingURL=landing.model.js.map
